import { RankingSelector } from 'feature/ranking/ranking-selector';
import { CLICK, CHECK_TEXT, componentWithVariants, demoFile, story, variant } from 'system/demo';

demoFile('feature/ranking/ranking-selector');

componentWithVariants('RankingSelector', RankingSelector, {}, [
    variant('Two Options', {
        config: {commentRankers: [
            {label: 'Newest', ranker: () => []},
            {label: 'Oldest', ranker: () => []}
        ]},
        args: {testID: 'ranking-select'}
    }, [
        story('Select Oldest', [
            CLICK('ranking-select'),
            CLICK('Oldest'),
            CHECK_TEXT('Oldest')
        ])
    ]),
    variant('One Option', {
        config: {commentRankers: [
            {label: 'Newest', ranker: () => []}
        ]},
        args: {testID: 'single-ranking'}
    })
]);
